<form [formGroup]="form">

  <app-input-group>
    <label appLabel>{{ 'chargeInformation.chargeType' | translate }}</label>
    <input appInput [value]= " ('chargeInformation.chargeTypes.' + form.get('chargeType')?.value.toLowerCase()) | translate "
           [readonly]="true">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'chargeInformation.chargeTypeId' | translate }}</label>
    <input appInput formControlName="chargeTypeId"
           [readonly]=true>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'chargeInformation.description' | translate }}</label>
    <input appInput formControlName="description"
           [readonly]=true>
  </app-input-group>


  <app-input-group>
    <label appLabel>{{ 'chargeInformation.validTo' | translate }}</label>
    <input type="date" appInput formControlName="validTo">
  </app-input-group>
</form>
